import styled from "@emotion/styled";
import Colors from "styles/colors";
import { RIVERSTONE_COLOR_NAME, WHITE_COLOR_NAME } from "styles/color-consts";
export const SEARCH_BAR_HEIGHT = 90;
export const SHADOW_VERTICAL_OFFSET = 4;
export const StyledSearchBarCareersComponent = styled.div`
  width: 100%;
  display: flex;
  background-color: ${Colors[WHITE_COLOR_NAME]};
  justify-content: center;
  flex-direction: row;
  padding-top: 24px;
  padding-bottom: 20px;
	height: ${SEARCH_BAR_HEIGHT}px;
  margin: 0 auto;
		
  &.nav-bar {
    box-shadow: 0 ${SHADOW_VERTICAL_OFFSET}px 4px rgba(29, 140, 242, 0.08);
  }
  .search-input-and-filters {
    max-width: 894px;
    display: flex;
    gap: 40px;
    width: 100%;

    .search-input {
      margin-left: 32px;
    }

    .filters {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-direction: row;
      gap: 8px;
      min-width: 320px;
      margin-right: 32px;
      .title {
        font-size: 0.875rem;
        color: ${Colors.jaco};
      }
    }
  }
`;
